<template>
    <div id="ObjectHousesFilter" class="pb-10">
        <v-expansion-panels flat>
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" hide-actions>
                    <template v-slot:default="{ open }">
                        <div class="d-flex align-center">
                            <div class="text-subtitle-1 font-weight-bold gray--text">Фильтр</div>
                            <v-icon color="gray" v-if="open">arrow_drop_up</v-icon>
                            <v-icon color="gray" v-else>arrow_drop_down</v-icon>
                        </div>
                    </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="v-row">
                    <v-row class="px-3">
                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                label="Категория потребителя"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="categories"
                                item-text="category_name"
                                item-value="category_rid"
                                v-model="filter.category_rid"
                                no-data-text="Нет категорий"
                            />
                        </v-col>

                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                label="Наименование объекта"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="objects"
                                item-text="object_name"
                                item-value="object_rid"
                                v-model="filter.object_rid"
                                no-data-text="Нет объектов"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                label="№ договора"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="contracts"
                                item-text="contract_number"
                                item-value="contract_rid"
                                v-model="filter.contract_rid"
                                no-data-text="Нет договоров"
                            />
                        </v-col>

                        <v-col cols="12" lg="6">
                            <v-text-field label="Адрес" color="gray" outlined dense clearable v-model="filter.address_full_name___ru" />
                        </v-col>

                        <v-col cols="12" lg="6">
                            <div class="gray--text mb-1">Выдано предписание:</div>

                            <v-checkbox
                                class="mt-0 issued-checkbox"
                                hide-details
                                dense
                                label="Выдано"
                                :input-value="filter.is_formed === 1"
                                @change="setIssued(true, $event)"
                            />

                            <v-checkbox
                                class="mt-0 issued-checkbox"
                                hide-details
                                dense
                                label="Не выдано"
                                :input-value="filter.is_formed === 0"
                                @change="setIssued(false, $event)"
                            />
                        </v-col>
                    </v-row>

                    <div class="px-3 pb-4">
                        <v-btn color="white" outlined @click="resetFilter" class="mr-4 gray--text">Сбросить</v-btn>
                        <v-btn color="gray" class="white--text" @click="applyFilter">Применить</v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    name: 'ObjectHousesFilter',
    props: {
        filterModel: { type: Object, required: true },
        contracts: { type: Array, default: () => [] },
        objects: { type: Array, default: () => [] },
        categories: { type: Array, default: () => [] },
        contractsLoading: { type: Boolean, default: false }
    },
    mounted() {},
    emits: ['update:filterModel', 'applyFilter', 'resetFilter'],
    data() {
        return {
            statusOptions: [
                { label: 'Сформировано', value: 'formed' },
                { label: 'Выдано', value: 'issued' },
                { label: 'Возвращено', value: 'returned' },
                { label: 'Подписано', value: 'signed' },
                { label: 'Выдан акт готовности', value: 'issued_act' },
                { label: 'Исполнено', value: 'completed' },
                { label: 'Проверено', value: 'checked' }
            ],
            yearMenu: false,
            minYear: 2015,
            maxYear: new Date().getFullYear() + 1
        };
    },
    computed: {
        filter: {
            get() {
                return this.filterModel;
            },
            set(value) {
                this.$emit('update:filterModel', value);
            }
        },

        yearDisplay() {
            return this.filter && this.filter.year ? String(this.filter.year) : '';
        },
        years() {
            const from = Number(this.minYear);
            const to = Number(this.maxYear);

            const arr = [];
            for (let y = to; y >= from; y--) arr.push(y);
            return arr;
        }
    },
    watch: {
        yearMenu(val) {
            if (val) {
                this.activePicker = 'YEAR';

                this.pickerDate = this.filter.year ? String(this.filter.year) : String(new Date().getFullYear());
            }
        },

        activePicker(val, old) {
            if (old === 'YEAR' && val === 'MONTH') {
                const y = parseInt((this.pickerDate || '').slice(0, 4), 10);
                const next = { ...this.filter, year: Number.isFinite(y) ? y : null };
                this.$emit('update:filterModel', next);

                this.$nextTick(() => {
                    this.yearMenu = false;
                    this.activePicker = 'YEAR';
                });
            }
        }
    },
    methods: {
        setIssued(value, checked) {
            this.filter = { ...this.filter, is_formed: checked ? (value ? 1 : 0) : null };
        },

        applyFilter() {
            this.$emit('applyFilter');
        },
        resetFilter() {
            this.$emit('resetFilter');
        },
        pickYear(y) {
            const next = { ...this.filter, year: y };
            this.$emit('update:filterModel', next);
            this.$nextTick(() => (this.yearMenu = false));
        },
        clearYear() {
            const next = { ...this.filter, year: null };
            this.$emit('update:filterModel', next);
        }
    }
};
</script>

<style>
#PrescriptionFilter .v-expansion-panel-content__wrap {
    padding: 0;
}
.status-row {
    flex-wrap: nowrap;
}

@media (min-width: 960px) {
    #PrescriptionFilter .status-col {
        flex: 1 0 0;
        max-width: none;
    }
}

.issued-checkbox .v-icon {
    color: #3f51b5 !important;
    opacity: 1 !important;
}

.issued-checkbox .v-input--selection-controls__input .v-icon,
.issued-checkbox .v-input--selection-controls__input .v-icon::before {
    color: #3f51b5 !important;
    opacity: 1 !important;
}

.issued-checkbox.v-input--is-dirty .v-input--selection-controls__input .v-icon,
.issued-checkbox.v-input--is-dirty .v-input--selection-controls__input .v-icon::before {
    color: #3f51b5 !important;
    opacity: 1 !important;
}
</style>
